import * as React from 'react';
import { Field } from '../dynamic-input-field/DynamicInputField';

import style from './DynamicRadioField.module.css';

type DynamicInputFieldProps = {
    api: any,
    field: Field,
}

const DynamicRadioField = (props: DynamicInputFieldProps) => {
    const dataStore = props.api.getDataStore(props.field);
    const [isValid, setValid] = React.useState(true);

    const handleOnChange = (e: any) => {
        dataStore.put(props.field.name, e.target.value);
        props.field.validation?.();
    };

    const validationStyling = isValid ? style.valid : style.invalid;
    
    props.field.validation = () => {
        if(!dataStore.get(props.field.name) || dataStore.get(props.field.name).trim().length == 0){
            console.log(!props.field.required)
            setValid(!props.field.required);
            return !props.field.required;
        }
        setValid(true);
        return true;
    };

    return (
        <div id={style.container}>
            <div id={style.fieldName}>{props.field.text}{props.field.required ? '*' : ''}</div>
            {
                props.field.metadata?.map((field: any, index: number) => {
                    return (
                        <div id={style.field} className={validationStyling} key={index + '_' + props.field.name + '_' + field.name + '_' + field.type}>
                            <input id={style.radio} onChange={handleOnChange} name={props.field.name} value={field.FormQuestionFieldID} type='radio' defaultChecked={dataStore.get(props.field.name) == field.FormQuestionFieldID}></input>
                            <label id={style.text}>{field.Name}</label>
                        </div>
                    )
                })
            }
        </div>
    )
}

export default DynamicRadioField;